var map = {
	"./0.jpg": 8004,
	"./1.jpg": 7056,
	"./10.jpg": 7596,
	"./11.jpg": 7132,
	"./12.jpg": 3784,
	"./13.jpg": 3440,
	"./2.jpg": 4543,
	"./3.jpg": 9504,
	"./4.jpg": 2379,
	"./5.jpg": 6900,
	"./6.jpg": 5028,
	"./7.jpg": 1728,
	"./8.jpg": 4204,
	"./9.jpg": 7496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6172;